/**
 * @module utils/stringHelpers
 */

import jwt_decode from 'jwt-decode'

export const limitLength = (str, length) => {
  if (str) {
    if (str.length <= length) {
      return str
    } else {
      let result = str.substring(0, length - 1)
      result += '...'
      return result
    }
  } else {
    return str
  }
}
export const formatSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return `${minutes < 10 ? `0${minutes}` : minutes}:${
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
  }`
}

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.floor(seconds % 60)
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
}

export const decodeToken = (token) => {
  try {
    return token ? jwt_decode(token) : null
  } catch (error) {
    console.error('Invalid token:', error.message)
    return null
  }
}

export default { limitLength, formatSeconds, formatTime, decodeToken }
